<template>
  <div :style="divStyle">
    <v-expansion-panels accordion>
      <v-expansion-panel v-for="(row, i) in datasource" :key="i" class="mb-5">
        <!-- 작업공정 안전보건정보 작성 -->
        <v-card class="addable-card d-flex">
          <div v-if="!readonly" class="ma-1 d-flex justify-center align-center">
            <v-btn text small @click="btnRemove(i)" height="calc(100% - 24px)" class="rounded-pill ma-3 pa-2" :color="'error'">
              <svg-icon icon-class="minus" style="height:20px" />
            </v-btn>
          </div>
          <v-card width="100%" class="pa-4 addable-contents">
            <v-simple-table class="custom-table">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text-center tableTitle">
                      유해요인
                    </td>
                    <td :class="getClass('text-center', readonly)" style="border-bottom: thin solid rgba(0, 0, 0, 0.12);" colspan="4">
                      <v-textarea
                        v-model="row.riskFactor"
                        solo
                        hide-details="auto"
                        alignment="right"
                        placeholder="유해요인을 입력하세요."
                        auto-grow
                        spellcheck="false"
                        :readonly="readonly"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center tableTitle">
                      감소대책
                    </td>
                    <td :class="getClass('text-center', readonly)" style="border-bottom: thin solid rgba(0, 0, 0, 0.12);" colspan="4">
                      <v-textarea
                        v-model="row.riskFactorReduce"
                        solo
                        hide-details="auto"
                        alignment="right"
                        placeholder="감소대책을 입력하세요."
                        auto-grow
                        spellcheck="false"
                        :readonly="readonly"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-card>
      </v-expansion-panel>
    </v-expansion-panels>
    <template v-if="!readonly">
      <v-btn elevation="0" @click="btnAdd" width="100%" height="48" class="table-add-btn ">
        <svg-icon icon-class="table-add" style="height: 20px" />
      </v-btn>
    </template>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'ReductionWritePanelTree',
  props: {
    tbmKey: {
      type: String,
      default: ''
    },
    datasource: {
      type: Array,
      default: () => []
    },
    divStyle: {
      type: String,
      default: 'width: 100%; height: 60vh; verflow-y:auto;'
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  watch: {},
  mounted() {},
  methods: {
    btnAdd() {
      const [clntId, compId, writeDt] = this.tbmKey.split('_')

      const row = {
        clntId: clntId,
        compId: compId,
        writeDt: writeDt,
        riskFactor: '',
        riskFactorReduce: '',
        __created__: true
      }

      this.datasource.push(row)
      console.log(this.datasource)
    },
    //삭제버튼
    btnRemove(index) {
      this.datasource.splice(index, 1)
    },
    getClass(textLocation, flag) {
      let checkMode = flag ? ' readonly' : ''
      let text = `${textLocation}${checkMode}`
      return text
    }
  }
}
</script>
<style lang="scss" scoped>
.tableTitle {
  width: 15%;
}
</style>
